import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, PLANO_DE_CONTA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    PLANO_DE_CONTA_ENDPOINT
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      PLANO_DE_CONTA_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    PLANO_DE_CONTA_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [PLANO_DE_CONTA_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [PLANO_DE_CONTA_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [PLANO_DE_CONTA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [PLANO_DE_CONTA_ENDPOINT],
    id
  );
}
